import { SvgIcon, SvgIconProps } from '@mui/material';

function SewingIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 2500.000000 2500.000000">
                <g transform="translate(0.000000,2600.000000) scale(0.100000,-0.100000)"
                    fill="currentColor" stroke="none">
                    <path d="M15023 24439 c-1003 -54 -1974 -406 -2779 -1007 -206 -153 -362 -289
-564 -492 -420 -419 -717 -833 -975 -1355 -354 -719 -526 -1458 -526 -2265 0
-709 130 -1355 402 -2004 424 -1010 1198 -1885 2152 -2437 70 -41 127 -76 127
-80 0 -3 -19 -16 -42 -29 -61 -34 -160 -108 -437 -325 l-241 -190 2277 -5
2278 -5 75 -22 c157 -44 281 -117 389 -226 104 -105 172 -222 213 -364 l23
-78 0 -2300 0 -2300 -33 -95 c-43 -125 -111 -237 -197 -325 -107 -109 -225
-181 -377 -227 -71 -22 -87 -22 -615 -26 l-543 -3 0 -367 c0 -417 -5 -458 -69
-587 -170 -344 -583 -473 -921 -288 -99 55 -217 179 -269 284 -66 134 -71 172
-71 591 l0 367 -557 4 c-618 4 -598 2 -751 73 -139 64 -267 174 -350 302 -21
33 -139 256 -261 496 -122 240 -226 438 -230 440 -4 3 -13 -43 -20 -102 -28
-250 -87 -637 -158 -1050 -7 -41 2 -43 -243 50 -509 195 -972 418 -1242 599
-47 32 -89 63 -92 68 -19 31 224 377 461 656 66 78 123 146 127 153 6 9 -142
12 -663 12 l-671 0 0 -1560 0 -1560 33 -21 c72 -45 573 -289 732 -357 l170
-72 293 0 c227 0 292 3 292 13 2 103 22 254 38 291 27 60 95 132 157 164 l50
27 2955 0 2955 0 56 -26 c76 -36 133 -89 165 -155 24 -50 40 -157 43 -290 1
-21 5 -22 204 -27 234 -5 296 -19 436 -93 212 -112 347 -278 417 -511 24 -80
27 -108 32 -295 l4 -208 560 0 c444 0 559 3 555 13 -2 6 -44 68 -92 137 -161
232 -384 606 -369 619 5 4 77 29 159 55 212 68 506 175 739 268 684 275 1254
591 1686 935 147 117 400 363 498 485 220 272 367 570 434 878 20 92 23 133
23 330 0 238 -6 285 -61 503 -139 551 -502 1187 -1082 1893 -579 705 -1418
1522 -2432 2368 -418 349 -1051 853 -1186 945 -54 36 -189 104 -248 125 -23 8
-30 2 84 71 916 553 1659 1406 2074 2383 403 946 513 1997 315 3002 -125 637
-390 1284 -744 1821 -199 301 -396 540 -665 809 -205 206 -360 340 -575 500
-950 708 -2138 1064 -3332 999z m3346 -12969 c581 -523 1145 -1085 1525 -1518
233 -266 458 -564 560 -743 l26 -47 -87 -59 c-285 -194 -773 -429 -1318 -633
-220 -83 -539 -189 -546 -182 -10 10 -94 463 -129 687 -86 561 -139 1094 -223
2252 -28 379 -30 440 -17 430 8 -7 102 -91 209 -187z"/>
                    <path d="M5837 15953 c-4 -3 -7 -78 -7 -165 l0 -158 95 0 95 0 0 -760 0 -760
-95 0 -95 0 0 -95 0 -95 -572 0 c-627 0 -654 -2 -764 -58 -120 -61 -215 -173
-254 -300 -18 -58 -20 -93 -20 -358 l0 -294 -39 25 c-107 71 -219 5 -316 -188
-146 -289 -229 -777 -229 -1352 0 -289 11 -453 45 -684 93 -645 312 -1008 513
-850 l26 20 0 -3358 c0 -3060 1 -3364 16 -3414 52 -175 189 -309 359 -354 52
-13 337 -15 2465 -15 l2406 0 28 58 c144 296 391 734 763 1352 451 750 603
1044 744 1442 40 115 98 325 124 455 l7 33 -906 0 -906 0 0 2115 0 2115 1421
-2 1420 -3 195 -380 c107 -209 276 -539 376 -734 165 -321 188 -361 246 -423
43 -45 85 -78 126 -98 123 -61 108 -60 848 -60 l677 0 3 -537 3 -538 26 -56
c34 -73 96 -134 168 -167 46 -22 71 -26 136 -26 132 0 233 60 296 176 l34 63
3 543 3 542 659 0 c442 0 676 4 712 11 187 39 348 200 387 387 8 38 11 687 11
2260 0 2428 4 2254 -61 2384 -63 125 -209 231 -353 257 -42 8 -1419 11 -4653
11 l-4593 0 0 95 0 95 -90 0 -90 0 0 760 0 760 90 0 90 0 0 165 0 165 -783 0
c-431 0 -787 -3 -790 -7z"/>
                    <path d="M11510 6551 c0 -15 -4 -86 -10 -157 -43 -551 -176 -992 -474 -1569
-125 -241 -212 -393 -511 -890 -575 -957 -758 -1305 -990 -1880 -118 -293
-293 -823 -277 -839 6 -7 10272 -8 10272 -2 0 2 -20 71 -44 153 -155 518 -373
1036 -664 1578 -110 206 -271 484 -577 995 -311 521 -392 663 -521 917 -243
480 -379 899 -433 1333 -11 89 -31 323 -31 366 l0 24 -2870 0 -2870 0 0 -29z"/>
                    <path d="M17635 6058 c3 -13 14 -63 24 -113 87 -398 260 -802 589 -1379 l97
-169 3 609 c1 410 -1 626 -9 662 -18 89 -75 190 -148 262 -121 119 -209 150
-423 150 -138 0 -138 0 -133 -22z"/>
                </g>
            </svg>

            {/* <svg viewBox="0 0 2200.000000 2200.000000" xmlns="http://www.w3.org/2000/svg">
                <g fill="currentColor" stroke="none" transform="translate(0.000000,2600.000000) scale(0.100000,-0.100000)">
                    <path d="M11709 22527 c-63 -34 -102 -100 -107 -183 l-4 -64 -2822 -3 c-2671
-2 -2825 -3 -2896 -20 -297 -71 -512 -188 -710 -387 -199 -199 -324 -430 -382
-709 -17 -85 -20 -161 -29 -676 -5 -319 -8 -1349 -6 -2290 l3 -1710 22 -99
c120 -523 415 -916 865 -1151 l100 -53 -114 -4 c-103 -3 -118 -6 -152 -29 -54
-37 -84 -83 -98 -147 -14 -69 -8 -485 8 -523 32 -75 122 -138 196 -139 l37 0
0 -79 c0 -59 4 -84 16 -95 13 -14 54 -16 298 -16 335 0 316 -7 316 113 l0 77
146 0 c136 0 146 -1 138 -17 -4 -10 -10 -46 -12 -80 l-4 -62 -51 -3 -52 -3 0
-95 0 -95 53 -3 52 -3 0 -35 c0 -26 8 -44 29 -65 l29 -29 291 0 291 0 32 29
33 29 3 168 c4 194 0 227 -33 260 l-24 24 44 45 c25 24 45 49 45 55 0 6 30 10
75 10 l75 0 0 -532 c0 -514 -1 -531 -18 -515 -15 14 -40 17 -129 17 -156 0
-148 12 -148 -247 0 -253 -6 -243 149 -243 76 0 107 4 124 16 16 11 22 12 22
3 0 -7 9 -32 20 -55 25 -50 68 -74 134 -74 l46 0 0 -214 c0 -134 4 -216 10
-218 6 -2 13 -113 18 -285 4 -155 11 -285 14 -288 3 -3 12 -3 20 0 12 5 16 52
21 288 4 182 10 283 17 285 6 2 10 77 10 218 l0 214 41 0 c51 0 102 24 126 58
17 25 18 73 21 800 l2 772 335 0 335 0 0 -80 c0 -86 15 -131 49 -150 11 -5 65
-10 120 -10 92 0 102 2 130 26 l31 26 0 395 0 395 -30 29 -30 30 -107 -5 c-60
-4 -162 -8 -228 -11 l-120 -5 75 25 c115 39 324 147 430 222 121 87 296 262
383 383 37 52 96 154 132 225 110 221 160 413 174 667 10 167 22 198 92 237
l37 21 2203 0 c1903 0 2214 -2 2274 -15 280 -60 516 -261 615 -526 52 -141 50
-49 50 -2112 0 -2119 4 -1985 -64 -2145 -100 -237 -300 -414 -558 -494 l-73
-23 -5450 -5 c-5211 -5 -5453 -6 -5524 -24 -324 -78 -566 -255 -724 -531 -55
-96 -111 -260 -127 -370 -8 -57 -10 -546 -8 -1700 l3 -1620 22 -78 c59 -205
150 -366 287 -503 179 -179 402 -285 661 -314 52 -6 397 -10 826 -10 l735 0
24 -56 c31 -76 110 -155 187 -185 l58 -24 623 -3 c539 -2 632 -1 685 13 109
28 200 108 242 213 l17 42 6424 0 6423 0 26 -59 c33 -73 102 -142 180 -178
l60 -28 645 0 c491 0 655 3 687 13 92 28 199 129 224 214 l12 36 501 5 c461 4
508 6 586 25 217 52 371 135 526 284 189 182 300 416 325 687 7 77 9 636 6
1661 -3 1534 -3 1546 -24 1631 -12 47 -35 122 -52 165 l-31 79 0 2807 0 2807
283 3 c276 3 283 4 332 28 64 31 134 101 165 165 l25 50 0 1520 0 1520 -22 47
c-28 62 -96 134 -153 163 -73 37 -139 45 -360 45 l-209 0 -4 498 c-3 419 -6
508 -20 567 -65 275 -189 504 -372 690 -172 175 -370 293 -605 361 -196 57
155 54 -5272 54 l-4998 0 0 58 c0 64 -24 125 -61 159 -62 56 -165 69 -240 30z
m-4299 -7782 l0 -135 -65 0 -65 0 0 135 0 135 65 0 65 0 0 -135z m1170 0 l0
-135 -335 0 -335 0 0 135 0 135 335 0 335 0 0 -135z"/>
                </g>
            </svg> */}
        </SvgIcon >
    );
}

export default SewingIcon;